const formatData = (values, cmsData, urlParams, language, marketCode) => {
  if (!values) return;

  const productGroupMap = {
    'N/A': -1,
    Uterum: 51,
    Trädgårdsbyggnader: 56,
    Växthus: 57,
    Ytterdörrar: 62,
    Garageportar: 63,
    Fönster: 64,
    Solskydd: 66,
    Förvaring: 72,
    Badrum: 76,
    MOK: 55,
  };

  const removeCharacters = (input) => {
    const cleanString = input.replace(/[<>]/g, '');

    return cleanString;
  };

  const eventInfo = {
    type: cmsData.type,
    language: language,
    productGroupId: productGroupMap[cmsData.productGroup],
    marketcode: marketCode,
    channel: 'web', // What do we want here and when?
    urlProps: JSON.stringify(urlParams),
  };

  const eventData = {
    formId: cmsData.id,
    formName: cmsData.name,
    formDescription: cmsData.description,
    validFrom: cmsData.startdate,
    validTo: cmsData.enddate,
    result: removeCharacters(JSON.stringify(values.form)),
    tac: values.tacCheckbox,
  };

  const formattedData = {
    eventInfo: { ...eventInfo },
    contactInfo: values.contact,
    eventData: { ...eventData },
    brevo: {
      ...cmsData.brevo,
    },
  };

  // Exclude 'id' property from brevo
  delete formattedData.brevo.id;

  return formattedData;
};

export default formatData;
